export let moreTooltip = "uxtMH";
export default {moreTooltip};